export default "__VITE_ASSET__BFXZTyZT__"